/**************************************************
 * Nombre:       IngresoTexto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Dialog, Fab, Grid, Typography} from "@mui/material";
import {AddAPhoto, Close, ContentCut,} from "@mui/icons-material";
import imgDefecto from '../Recursos/imgDefecto.svg'
import {useEffect, useState} from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";


const IngresoImagenCrop = ({
                               props,
                               dato,
                               alto = 1,
                               ancho = 1

                           }) => {
    const {getValues, setValue, watch} = props
    const [imagen, setImagen] = useState('')
    const [open, setOpen] = useState(false)
    const [cropper, setCropper] = useState("");

    const abrir = () => {
        setOpen(true)
    }

    const cerrar = () => {
        setImagen('')
        setOpen(false)
    }

    const getCropData = () => {

        if (typeof cropper !== "undefined") {
            cerrar()

            cropper.getCroppedCanvas().toBlob(function (blob) {
                let imgFile = blobToFile(blob, 'nombre')
                setValue(dato, imgFile)
            });

        }
    };


    function blobToFile(theBlob, fileName) {
        theBlob.lastModifiedDate = new Date();
        theBlob.name = fileName;
        return theBlob;
    }

    const ingresoImagen = (data) => {
        if (data.target.files && data.target.files[0]) {
            let urlImagen = URL.createObjectURL(data.target.files[0])
            setImagen(urlImagen)
            abrir()
        }
    }


    useEffect(() => {
        let obj = getValues()

      //  console.log('img', obj[dato])

        if (typeof obj[dato] === 'object') {
            setImagen(URL.createObjectURL(obj[dato]))
        } else if (obj[dato] !== undefined) {
            console.log(obj[dato])
            setImagen(obj[dato])
        }

    }, [watch(dato)]);
    return (


        <Grid
            container
            justifyContent={'center'}
            alignItems={'center'}
            size={12}
        >
            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                <img src={imagen ? imagen : imgDefecto} width={150} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}
                  sx={{mr: -15, mt: -7}}
            >
                <Fab
                    variant="contained"
                    component="label"
                    sx={{p: 2}}
                >
                    <input
                        type="file"
                        hidden
                        onChange={ingresoImagen}

                    />
                    <AddAPhoto color={'primary'} sx={{width: 30, height: 30}}/>

                </Fab>
            </Grid>


            <Dialog open={open} fullWidth maxWidth={"xs"}
                    PaperProps={{
                        style: {borderRadius: 10}
                    }}
            >

                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={12}

                >

                    <Grid container size={12} sx={{justifyContent: 'flex-end', marginTop: 2, px: 3}}>
                        <Button
                            onClick={() => cerrar()}
                            variant={'text'} sx={{color: '#00000080'}} endIcon={<Close/>}>Cancelar</Button>
                    </Grid>

                    <Grid container size={12} sx={{justifyContent: 'center', marginTop: 4}}>
                        <Typography sx={{fontSize: 20, fontWeight: 600}}>Recortar Imagen</Typography>

                    </Grid>

                    <Grid container size={12} sx={{justifyContent: "center", marginTop: 4}}>

                        <Grid
                            container
                            justifyContent={'center'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}>


                            <Cropper
                                style={{
                                    height: 350,
                                    width: 350,
                                }}
                                src={imagen}
                                viewMode={2}
                                guides={true}
                                minCropBoxHeight={10}
                                minCropBoxWidth={10}
                                background={true}
                                responsive={true}
                                autoCropArea={0.5}
                                modal={true}
                                checkOrientation={false}
                                onInitialized={(instance) => {
                                    setCropper(instance);
                                }}
                                aspectRatio={ancho / alto}
                            />

                        </Grid>

                    </Grid>

                    <Grid container size={12} sx={{justifyContent: "center", marginTop: 4, marginBottom: 4}}>
                        <Button startIcon={<ContentCut/>} color={"primary"}
                                onClick={() => getCropData()}
                        >Realizar Recorte</Button>
                    </Grid>

                </Grid>

            </Dialog>

        </Grid>

    )

}
export default IngresoImagenCrop
